var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.813,
    height: 22.651,
    viewBox: "0 0 23.813 22.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.73,126.55l-3.1-6.673a.554.554,0,0,0-.526-.277H17.445a.554.554,0,1,0,0,1.108h2.3l2.575,5.538H19.162a3.627,3.627,0,0,0-3.323,2.132,2.575,2.575,0,0,1-2.326,1.468H10.3a2.575,2.575,0,0,1-2.326-1.468,3.627,3.627,0,0,0-3.323-2.132h-3.1L4.6,120.708H6.369a.554.554,0,1,0,0-1.108h-2.1a.526.526,0,0,0-.5.249l-3.655,6.7a.332.332,0,0,0-.111.222v6.895a2.908,2.908,0,0,0,2.852,2.824H20.961a2.907,2.907,0,0,0,2.852-2.824v-6.895A.526.526,0,0,0,23.73,126.55Z",
    transform: "translate(0 -113.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M148.071,23.792a.526.526,0,0,0,.743.032l.032-.032L152.612,20a.554.554,0,0,0-.775-.775l-2.824,2.824V11.525a.554.554,0,1,0-1.108,0V22.047l-2.824-2.824a.554.554,0,0,0-.775.775Z",
    transform: "translate(-136.552 -10.971)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.1dd86506.svg";
export { ForwardRef as ReactComponent };